import { ScheduleTestID } from "@/constants/TestID";
import { IllustrationSize } from "@/constants/UI";
import Avatar from "@/ui/core/Avatar";
import { Box, HStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface EventAttendeesListProps {
  attendees?: BaseUserAvatarProps[];
}
const baseTestID = joinTestIDs(
  ScheduleTestID.ScheduleEventCard,
  "attendees-list",
);

const EventAttendeesList = ({ attendees }: EventAttendeesListProps) => {
  return (
    <HStack>
      {/* eslint-disable-next-line max-params */}
      {attendees?.slice(0, 6).map((attendee, index) => {
        const initialZIndex = 10;
        const zIndex = initialZIndex - index;
        const lastIndex = attendees.length - 1;
        return (
          <Box
            accessibilityLabel={`${attendee.userName} avatar`}
            alignItems="center"
            borderColor={index === lastIndex ? "transparent" : "white"}
            borderRadius={18}
            borderWidth={2}
            height={IllustrationSize.PreviewCard}
            justifyContent="center"
            key={attendee.userId}
            marginLeft={index === 0 ? "unset" : -8}
            width={IllustrationSize.PreviewCard}
            zIndex={zIndex}
          >
            <Avatar
              size="xs"
              testID={baseTestID}
              userId={attendee.userId}
              userName={attendee.userName}
              userType={attendee.userType}
            />
          </Box>
        );
      })}
    </HStack>
  );
};

export default EventAttendeesList;
